import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/award_icon.svg")